(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-journey]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var steps = root.querySelectorAll('[data-journey-step]');
      var shots = root.querySelectorAll('[data-journey-shot]');
      var count = root.querySelector('[data-journey-count]');
      var fill = root.querySelector('[data-journey-fill]');
      var list = root.querySelector('.v2-jr-steps');
      if (!steps.length) return;

      function activate(i) {
        steps.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
        shots.forEach(function (s) { s.classList.toggle('is-on', Number(s.getAttribute('data-journey-shot')) === i); });
        if (count) count.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) activate(Number(e.target.getAttribute('data-journey-step')));
          });
        }, { rootMargin: '-45% 0px -45% 0px' });
        steps.forEach(function (s) { io.observe(s); });
      }

      // the rail fills as the reader moves through the steps
      function rail() {
        if (!fill || !list) return;
        var r = list.getBoundingClientRect();
        var mid = window.innerHeight / 2;
        var p = (mid - r.top) / Math.max(1, r.height);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        fill.style.transform = 'scaleY(' + p.toFixed(3) + ')';
      }
      window.addEventListener('scroll', rail, { passive: true });
      window.addEventListener('resize', rail);
      rail();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-slider]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var track = root.querySelector('[data-slider-track]');
      var dots = root.querySelectorAll('[data-slider-dot]');
      if (!track || dots.length < 2) return;
      var current = 0;
      var rtl = getComputedStyle(track).direction === 'rtl';

      function go(i) {
        current = (i + dots.length) % dots.length;
        var x = track.clientWidth * current;
        track.scrollTo({ left: rtl ? -x : x, behavior: 'smooth' });
      }
      track.addEventListener('scroll', function () {
        var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        current = i;
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }, { passive: true });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); restart(); }); });

      var secs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      function restart() {
        if (timer) clearInterval(timer);
        if (secs > 0 && !still) timer = setInterval(function () { go(current + 1); }, secs * 1000);
      }
      root.addEventListener('pointerenter', function () { if (timer) clearInterval(timer); });
      root.addEventListener('pointerleave', restart);
      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
